export default function (http) {
    return {


        queryByPage(data) {
            return http.json({
                url: `/sku/base/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        queryBaseList(data) {
            return http.json({
                url: `/sku/base/queryBaseList?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        queryOrderList(data) {
            return http.json({
                url: `/sku/base/queryOrderList?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        queryById(data) {
            return http.json({
                url: `/sku/base/queryById?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        queryAll(data) {
            return http.json({
                url: `/sku/base/queryAll`,
                data
            });
        },
        getInfo2(data) {
            return http.json({
                url: `/sku/roster/get?id=1`,
                data
            })
        },
        getInfo(data) {
            return http.json({
                url: `/sku/base/get?id=${data.id}`,
                data
            })
        },

        getSchoolQrCode(data) {
            return http.json({
                url: `/sku/base/getSchoolQrCode`,
                data
            })
        },
        saveInfo(data) {
            return http.json({
                url: `/sku/base/save`,
                data
            })
        },
        saveTest(data) {
            return http.json({
                url: `/sku/base/saveTest`,
                data
            })
        },
        saveErrorSchool(data) {
            return http.json({
                url: `/sku/base/saveErrorSchool`,
                data
            })
        },

        saveSchool(data) {
            return http.json({
                url: `/sku/base/saveSchool`,
                data
            })
        },


        getOne(data) {
            return http.json({
                url: `/sku/base/getOne`,
                data
            })
        },


        delete(data) {
            return http.json({
                url: `/sku/base/delete`,
                data
            })
        },

        updateGradeSystem(data) {
            return http.json({
                url: `/sku/base/updateGradeSystem`,
                data
            })
        },

        getOptionsData(data){
            return http.json({
                url: `/sys/dict/getOne`,
                data:data,
            })
        }
    }
}





// WEBPACK FOOTER //
// ./src/configure/http/api/enroll/skuBase.js